import type { ModelData } from '../../types'

export const dragonPortal: { [key: string]: ModelData } = {
  'dragon-2-portal': {
    id: 'dragon-2-portal',
    name: 'DRAGON 2 PORTAL',
    power: '13 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-2-portal.jpg',
    emailSubject: 'Zapytanie - DRAGON 2 PORTAL',
    description: 'Wkład powietrzny portalowy 12 kW',
    basePrices: {
      standard: { single: 8460, double: 9100, triple: 9850 },
      lift: { single: 11400, double: 12040, triple: 12790 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 360, 'flush-30': 410, 'recessed-15': 450, 'recessed-30': 530, 'recessed-15-45': 560 },
        lift: { none: 0, 'recessed-lift-15': 420, 'recessed-lift-30': 500, 'recessed-lift-5': 950 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745
        // 'rt-08-om-duo-integra': 2170,
        // 'rt-08-om-grafik-duo-integra': 2200,
        // 'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '77,3%',
      energyClass: 'A',
      glassSize: '655 x 471 mm',
      insertSize: '748 x 936 x 451 mm',
      maxLogLength: '490 mm',
      weight: '223 kg'
    },
    perkData: {
      variant: {
        standard: { icon: '🚪', value: 'Standard', color: '#4a9eff' },
        lift: { icon: '⬆️', value: 'LIFT', color: '#ff6b4a' }
      },
      glass: {
        single: { icon: '🪟', value: 'x1', color: '#e6f3ff' },
        double: { icon: '🪟', value: 'x2', color: '#b3d9ff' },
        triple: { icon: '🪟', value: 'x3', color: '#80c7ff' }
      },
      ceramic: {
        'refrabox-light': { icon: '🧱', value: 'Jasna', color: '#f5f1e8' },
        'cerabox-graphite': { icon: '🧱', value: 'Grafitowa', color: '#4a4a4a' }
      },
      handle: {
        'classic-black': { icon: '🔗', value: 'Classic', color: '#333' },
        'classic-silver': { icon: '🔗', value: 'Classic', color: '#c0c0c0' },
        'design-black': { icon: '🔗', value: 'Design', color: '#1a1a1a' },
        'design-black-silver': { icon: '🔗', value: 'Design', color: 'linear-gradient(45deg,#333,#c0c0c0)' }
      },
      bezel: {
        none: { icon: '⭕', value: 'Brak', color: '#666' },
        'flush-15': { icon: '⭕', value: 'Licująca', color: '#8b4513' },
        'flush-30': { icon: '⭕', value: 'Licująca', color: '#8b4513' },
        'recessed-15': { icon: '⭕', value: 'Zagłębiająca', color: '#654321' },
        'recessed-30': { icon: '⭕', value: 'Zagłębiająca', color: '#654321' },
        'recessed-15-45': { icon: '⭕', value: 'Zagłębiająca', color: '#654321' },
        'recessed-lift-15': { icon: '⭕', value: 'LIFT', color: '#ff6b4a' },
        'recessed-lift-30': { icon: '⭕', value: 'LIFT', color: '#ff6b4a' },
        'recessed-lift-5': { icon: '⭕', value: 'LIFT', color: '#ff6b4a' }
      },
      fusion: {
        none: { icon: '♨️', value: 'Brak', color: '#666' },
        fusion: { icon: '♨️', value: 'FUSION', color: '#ff4500' },
        'fusion-corner': { icon: '♨️', value: 'CORNER', color: '#ff6347' }
      }
    },
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK'
        // 'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 2 PORTAL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2 PORTAL w konfiguracji:\n\nModel: DRAGON 2 PORTAL\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-2-xl-portal': {
    id: 'dragon-2-xl-portal',
    name: 'DRAGON 2 XL PORTAL',
    power: '13 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-2-xl-portal.jpg',
    emailSubject: 'Zapytanie - DRAGON 2 XL PORTAL',
    description: 'Wkład powietrzny portalowy 12 kW',
    basePrices: {
      standard: { single: 8890, double: 9580, triple: 10330 },
      lift: { single: 11830, double: 12520, triple: 13270 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 370, 'flush-30': 420, 'recessed-15': 490, 'recessed-30': 550, 'recessed-15-45': 600 },
        lift: { none: 0, 'recessed-lift-15': 440, 'recessed-lift-30': 510, 'recessed-lift-5': 960 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745
        // 'rt-08-om-duo-integra': 2170,
        // 'rt-08-om-grafik-duo-integra': 2200,
        // 'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '77,3%',
      energyClass: 'A',
      glassSize: '655 x 514 mm',
      insertSize: '748 x 979 x 451 mm',
      maxLogLength: '490 mm',
      weight: '163 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK'
        // 'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 2 XL PORTAL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2 XL PORTAL w konfiguracji:\n\nModel: DRAGON 2 XL PORTAL\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-4-slim-portal': {
    id: 'dragon-4-slim-portal',
    name: 'DRAGON 4 SLIM PORTAL',
    power: '14 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-slim-portal.jpg',
    emailSubject: 'Zapytanie - DRAGON 4 SLIM PORTAL',
    description: 'Wkład powietrzny portalowy 14 kW',
    basePrices: {
      standard: { single: 8990, double: 9740, triple: 10540 },
      lift: { single: 11940, double: 12680, triple: 13490 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 440, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 },
        lift: { none: 0, 'recessed-lift-15': 450, 'recessed-lift-30': 530, 'recessed-lift-5': 990 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745
        // 'rt-08-om-duo-integra': 2170,
        // 'rt-08-om-grafik-duo-integra': 2200,
        // 'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '14 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '717 x 471 mm',
      insertSize: '838 x 926 x 492 mm',
      fireplaceSize: '438 x 596 x 285 mm',
      maxLogLength: '580 mm',
      weight: '177 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licząca 15mm',
        'flush-30': 'Licząca 30mm',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK'
        // 'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4 SLIM PORTAL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 SLIM PORTAL w konfiguracji:\n\nModel: DRAGON 4 SLIM PORTAL\nMoc: 14 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-6-xxl-portal': {
    id: 'dragon-6-xxl-portal',
    name: 'DRAGON 6 XXL PORTAL',
    power: '12 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-6-xxl-portal.jpg',
    emailSubject: 'Zapytanie - DRAGON 6 XXL PORTAL',
    description: 'Wkład powietrzny portalowy 12 kW',
    basePrices: {
      standard: { single: 10280, double: 11350, triple: 12630 },
      lift: { single: 13220, double: 14290, triple: 15570 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 420, 'flush-30': 500, 'recessed-15': 550, 'recessed-30': 640, 'recessed-15-45': 690 },
        lift: { none: 0, 'recessed-lift-15': 510, 'recessed-lift-30': 580, 'recessed-lift-5': 1100 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 300 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745
        // 'rt-08-om-duo-integra': 2170,
        // 'rt-08-om-grafik-duo-integra': 2200,
        // 'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '754 x 604 mm',
      insertSize: '851 x 1153 x 461 mm',
      fireplaceSize: '590 x 659 x 280 mm',
      maxLogLength: '650 mm',
      weight: '208 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licząca 15mm',
        'flush-30': 'Licząca 30mm',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK'
        // 'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 6 XXL PORTAL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 6 XXL PORTAL w konfiguracji:\n\nModel: DRAGON 6 XXL PORTAL\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-4-portal': {
    id: 'dragon-4-portal',
    name: 'DRAGON 4 PORTAL',
    power: '16 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-portal.jpg',
    emailSubject: 'Zapytanie - DRAGON 4 PORTAL',
    description: 'Wkład powietrzny portalowy 16 kW',
    basePrices: {
      standard: { single: 9370, double: 10120, triple: 10920 },
      lift: { single: 12310, double: 13060, triple: 13860 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 440, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 },
        lift: { none: 0, 'recessed-lift-15': 450, 'recessed-lift-30': 530, 'recessed-lift-5': 990 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745
        // 'rt-08-om-duo-integra': 2170,
        // 'rt-08-om-grafik-duo-integra': 2200,
        // 'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '15,5 kW',
      efficiency: '78,6%',
      energyClass: 'A',
      glassSize: '717 x 471 mm',
      insertSize: '717 x 926 x 592 mm',
      fireplaceSize: '438 x 564 x 370 mm',
      maxLogLength: '530 mm',
      weight: '183 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK'
        // 'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4 XL PORTAL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 PORTAL w konfiguracji:\n\nModel: DRAGON 4 PORTAL\nMoc: 16 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-4-slim-xl-portal': {
    id: 'dragon-4-slim-xl-portal',
    name: 'DRAGON 4 SLIM XL PORTAL',
    power: '14 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-slim-xl-portal.jpg',
    emailSubject: 'Zapytanie - DRAGON 4 SLIM XL PORTAL',
    description: 'Wkład powietrzny portalowy 14 kW',
    basePrices: {
      standard: { single: 9370, double: 10220, triple: 11190 },
      lift: { single: 12310, double: 13170, triple: 14130 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 440, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 },
        lift: { none: 0, 'recessed-lift-15': 450, 'recessed-lift-30': 530, 'recessed-lift-5': 990 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745
        // 'rt-08-om-duo-integra': 2170,
        // 'rt-08-om-grafik-duo-integra': 2200,
        // 'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '14 kW',
      efficiency: '77,0%',
      energyClass: 'A',
      glassSize: '717 x 514 mm',
      insertSize: '838 x 969 x 492 mm',
      fireplaceSize: '480 x 564 x 370 mm',
      maxLogLength: '550 mm',
      weight: '175 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK'
        // 'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4 SLIM XL PORTAL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 SLIM XL PORTAL w konfiguracji:\n\nModel: DRAGON 4 SLIM XL PORTAL\nMoc: 14 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-4-xl-portal': {
    id: 'dragon-4-xl-portal',
    name: 'DRAGON 4 XL PORTAL',
    power: '16 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-xl-portal.jpg',
    emailSubject: 'Zapytanie - DRAGON 4 XL PORTAL',
    description: 'Wkład powietrzny portalowy 16 kW',
    basePrices: {
      standard: { single: 10060, double: 10920, triple: 11880 },
      lift: { single: 13010, double: 13860, triple: 14820 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 440, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 },
        lift: { none: 0, 'recessed-lift-15': 450, 'recessed-lift-30': 530, 'recessed-lift-5': 990 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 300 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745
        // 'rt-08-om-duo-integra': 2170,
        // 'rt-08-om-grafik-duo-integra': 2200,
        // 'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '15,5 kW',
      efficiency: '78,6%',
      energyClass: 'A',
      glassSize: '717 x 514 mm',
      insertSize: '818 x 969 x 592 mm',
      fireplaceSize: '480 x 564 x 370 mm',
      maxLogLength: '550 mm',
      weight: '191 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK'
        // 'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4 XL PORTAL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 XL PORTAL w konfiguracji:\n\nModel: DRAGON 4 XL PORTAL\nMoc: 16 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-6-xl-portal': {
    id: 'dragon-6-xl-portal',
    name: 'DRAGON 6 XL PORTAL',
    power: '12 kW',
    type: 'powietrzny nofusion',
    glassType: 'prosta' as const,
    image: 'images/dragon-6-xl-portal.jpg',
    emailSubject: 'Zapytanie - DRAGON 6 XL PORTAL',
    description: 'Wkład powietrzny portalowy 12 kW',
    basePrices: {
      standard: { single: 9630, double: 10490, triple: 11450 },
      lift: { single: 12580, double: 13430, triple: 14400 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 440, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 },
        lift: { none: 0, 'recessed-lift-15': 450, 'recessed-lift-30': 530, 'recessed-lift-5': 990 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 300 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '754 x 454 mm',
      insertSize: '851 x 1003 x 461 mm',
      fireplaceSize: '590 x 659 x 325 mm',
      maxLogLength: '650 mm',
      weight: '197 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok', 
        lift: 'LIFT - podnoszenie do góry' 
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK'
        // 'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        // 'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 6 XL PORTAL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 6 XL PORTAL w konfiguracji:\n\nModel: DRAGON 6 XL PORTAL\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  }
}



